import classNames from "classnames";
import styles from "./EmailListItem.module.scss";
import { formatGmailInternalDate, isGmailMessageUnread } from "../../_constants/gmailDisplay.const";
import type { GmailMessageListItem } from "../../_types/gmail.types";

type EmailListItemProps = {
  message: GmailMessageListItem;
  onClick: () => void;
};

export const EmailListItem = ({ message, onClick }: EmailListItemProps) => {
  const unread = isGmailMessageUnread(message.labelIds);
  const fromDisplay = message.from ?? "—";
  const subjectDisplay = message.subject ?? "(No subject)";

  return (
    <button type="button" className={styles["comp"]} onClick={onClick}>
      <div
        className={classNames(
          styles["comp__from"],
          unread && styles["comp__from--unread"],
        )}
      >
        {fromDisplay}
      </div>
      <div
        className={classNames(
          styles["comp__subject"],
          unread && styles["comp__subject--unread"],
        )}
      >
        {subjectDisplay}
      </div>
      <div className={styles["comp__snippet"]}>{message.snippet}</div>
      <time className={styles["comp__date"]}>
        {formatGmailInternalDate(message.internalDate)}
      </time>
    </button>
  );
};
